<template>
  <div>
    <Head title="Orders" />
    <h1 id="pg-tittle" class="page-title">{{ title }}</h1>
    <div class="toolbar">
      <search-filter v-model="form.search" class="w-full max-w-xl" @reset="reset">
<!--        <label class="block text-gray-700">Status:</label>-->
<!--        <select v-model="form.status" class="form-select mt-1 w-full">-->
<!--          <option :value="null">Any</option>-->
<!--          <option value="pending">Pending</option>-->
<!--          <option value="followup">Followup</option>-->
<!--          <option value="confirmed">Confirmed</option>-->
<!--          <option value="canceled">Canceled</option>-->
<!--        </select>-->
      </search-filter>
      <Datepicker v-model="date_form.dispatch_date" class="w-full max-w-md" range :enable-time-picker="false" :partial-range="false" />
    </div>
    <div class="mb-4 panel flex items-center justify-between p-3" v-show="selected.length > 0">
      <span class="text-sm font-bold text-gray-700">{{ selected.length }} selected</span>
      <button v-show="selected.length > 0" class="btn-indigo my-2" @click="mark_selected_as_complete">
        <icon name="check" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> <span class="hidden md:inline">&nbsp; Mark as Dispatched</span>
      </button>
    </div>
    <div class="table-card">
      <table class="data-table">
        <thead>
          <tr class="text-left font-bold">
            <th>
              <input id="default-checkbox" v-model="selectAll" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
            </th>
            <th>Order ID</th>
            <th v-if="view === 'to_dispatch'">Confirmed At</th>
            <th v-if="view === 'dispatched'">Dispatched At</th>
            <th v-if="view === 'to_cancel'">Requested At</th>
            <th v-if="view === 'cancelled'">Cancelled At</th>
            <th v-if="view === 'to_cancel' || view === 'cancelled'">Cancel Reason</th>
            <th>Name</th>
            <th>Order Value</th>
            <th>Delivery PIN</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
            <th />
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders.data" :id="`order_${order.id}`" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t px-1">
              <input id="default-checkbox" v-model="selected" :value="order.id" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
                <a href="">{{ order.order_id }}</a>
              </Link>
            </td>
            <td v-if="view === 'to_dispatch'" class="border-t">
              <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
                <span v-if="order.sla_breach && order.status === 'confirmed'" class="sla-chip">{{ order.date_time }}</span>
                <span v-else>{{ order.date_time }}</span>
              </Link>
            </td>
            <td v-if="view === 'dispatched'" class="border-t">
              <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
                <span>{{ order.dispatched_at }}</span>
              </Link>
            </td>
            <td v-if="view === 'to_cancel'" class="border-t">
              <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
                <span v-if="order.cancel_sla_breach && order.status === 'cancelled'" class="sla-chip">{{ order.cancel_requested_at }}</span>
                <span v-else>{{ order.cancel_requested_at }}</span>
              </Link>
            </td>
            <td v-if="view === 'cancelled'" class="border-t">
              <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
                <span>{{ order.cancelled_at }}</span>
              </Link>
            </td>
            <td v-if="view === 'to_cancel' || view === 'cancelled'" class="border-t">
              <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
                {{ order.cancel_reason }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
                {{ order.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
                ₹ {{ order.value }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="px-1 text-xs" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
<!--                <p>{{ order.shipping_address.address_1 }}</p>-->
<!--                <p v-if="order.shipping_address.address_2">{{ order.shipping_address.address_2 }}<br /></p>-->
<!--                <p>{{ order.shipping_address.city }}</p>-->
<!--                <p>{{ order.shipping_address.state }} {{ order.shipping_address.postcode }}</p>-->
                <p>{{ order.shipping_address.zip || order.shipping_address.postcode || 'N/A' }}</p>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
                {{ order.email }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
                {{ order.phone_number }}
              </Link>
            </td>
            <td class="border-t">
              <span class="flex items-center px-1">
                <span v-if="order.status === 'pending'" class="pill_blue">Pending</span>
                <span v-if="order.status === 'confirmed'" class="pill_green">Confirmed</span>
                <span v-if="order.status === 'cancelled'" class="pill_blue">Pending Cancellation</span>
                <span v-if="order.status === 'followup'" class="pill_yellow">Followup</span>
                <span v-if="order.status === 'dispatched'" class="pill_grey">Completed</span>
                <span v-if="order.status === 'cancel_completed'" class="pill_red">Cancelled</span>
              </span>
            </td>
            <td class="border-t">
              <button v-if="order.status === 'confirmed'" class="btn-green" @click="mark_order_as_completed(order.id)">
                <icon name="check" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Dispatch
              </button>

              <button v-if="order.status === 'cancelled'" class="btn-green" @click="mark_order_as_cancelled(order.id)">
                <icon name="check" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Mark as Cancelled
              </button>

              <button v-if="order.status === 'dispatched'" class="btn-grey" @click="open_undo_modal(order)">
                <icon name="undo" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Undo
              </button>

              <button v-if="order.status === 'cancel_completed'" class="btn-grey" @click="open_undo_modal(order)">
                <icon name="undo" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Undo
              </button>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-1" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="orders.data.length === 0">
            <td class="empty-state" colspan="13">No orders found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="orders.links" />

    <modal v-model="show_undo_modal" @confirm="undo_action(undo_order, form.undo_reason)" @cancel="cancel">
      <template v-slot:title>Undo Order #{{undo_order.id}} Status</template>
      <textarea-input v-model="form.undo_reason" class="pb-8 pr-6 w-full" label="Undo Reason" />
    </modal>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextareaInput from '@/Shared/TextareaInput'
import Modal from '@/Shared/Modal.vue'
import axios from 'axios'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import {  startOfMonth } from 'date-fns'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    TextareaInput,
    Modal,
    Datepicker,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    users: Array,
    assignedTo: Array,
    admin: Boolean,
    title: String,
    view: String,
    status: String,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        undo_reason: null,
      },
      date_form: {
        dispatch_date: this.filters.dispatch_date ?? [startOfMonth(new Date()), new Date()],
      },
      assign: {
        order_id: null,
        user_id: null,
      },
      selected: [],
      undo_order: [],
      show_undo_modal: false,
    }
  },
  computed: {
    selectAll: {
      get: function () {
        return this.orders.data ? this.selected.length === this.orders.data.length : false
      },
      set: function (value) {
        let selected = []

        if (value) {
          this.orders.data.forEach(function (order) {
            selected.push(order.id)
          })
        }

        this.selected = selected
      },
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/dispatch/all', pickBy(this.form), { preserveState: true })
      }, 150),
    },
    date_form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/dispatch/'+this.status, pickBy(this.date_form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    mark_selected_as_complete() {
      //console.log(this.selected)
      this.$inertia.post('/dispatch/dispatch_orders', {'order_ids': this.selected})
    },

    mark_order_as_completed (order_id) {
      this.$inertia.post('/dispatch/dispatch_orders', {'order_ids': [order_id]})
    },

    mark_order_as_cancelled (order_id) {
      this.$inertia.post('/dispatch/cancel_orders', {'order_ids': [order_id]})
    },

    open_undo_modal(order) {
      this.undo_order = order
      this.form.undo_reason = ''
      this.show_undo_modal = true
    },

    undo_action (order, reason) {

      if (reason.length < 5) {
        window.alert('Please enter a valid undo reason.')
        return
      }

      if (order.status === 'dispatched') {
        this.undo_complete_order(order.id, reason)
      }

      if (order.status === 'cancel_completed') {
        this.undo_cancelled_order(order.id, reason)
      }

      this.show_undo_modal = false;
    },

    undo_complete_order (order_id, reason) {
      this.$inertia.post('/dispatch/dispatch_orders', {'order_ids': [order_id], undo: true, undo_reason: reason})
    },

    undo_cancelled_order (order_id, reason) {
      this.$inertia.post('/dispatch/cancel_orders', {'order_ids': [order_id], undo: true, undo_reason: reason})
    },

    assign_user(order_id, user_id) {

      let params = (new URL(document.location)).searchParams
      let unassigned = params.get('unassigned')

      if(unassigned) {
        this.$inertia.post('/orders/'+order_id+'/assign', {'user_id' : user_id})
        return
      }

      //this.$inertia.put('/orders/'+order_id+'/assign', {'user_id' : user_id});
      let url =  '/orders/'+order_id+'/assign'
      axios({
        method: 'post',
        url:url,
        data: {'user_id' : user_id},
      }).then(function () {
        document.getElementById('order_'+order_id).classList.remove('hover:bg-gray-100')
        document.getElementById('order_'+order_id).classList.remove('focus-within:bg-gray-100')
        document.getElementById('order_'+order_id).classList.add('bg-green-100')

        setTimeout(() => {
          document.getElementById('order_'+order_id).classList.remove('bg-green-100')
          document.getElementById('order_'+order_id).classList.add('hover:bg-gray-100')
          document.getElementById('order_'+order_id).classList.add('focus-within:bg-gray-100')
        },1000)
      }).catch(function () {
        alert('Failed to save update. Please try again.')
        this.$inertia.reload({ only: ['orders', 'main-menu'] })
      })
    },
  },
}
</script>
